"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entitySelectField = void 0;
var react_1 = __importDefault(require("react"));
var pluralize_1 = require("pluralize");
var input_select_1 = require("../components/forms/input-select");
var lodash_1 = require("lodash");
var entitySelectField = function (args) {
  var name = args.name,
    placeholder = args.placeholder,
    isAvailable = args.isAvailable,
    required = args.required,
    _a = args.isClearable,
    isClearable = _a === void 0 ? true : _a,
    label = args.label,
    description = args.description,
    context = args.context,
    options = args.options,
    _b = args.fieldSet,
    fieldSet = _b === void 0 ? 'overview' : _b;
  var isMulti = args.isMulti === undefined ? (0, pluralize_1.isPlural)(name) : args.isMulti;
  var focus = !!args.focus;
  // (context: EntityFormFieldsDeriverContext, option: SelectOption & { hasAccount: boolean })
  var isOptionDisabled = args.isOptionDisabled && args.isOptionDisabled(context);
  return {
    name: name,
    fieldSet: fieldSet,
    focus: focus,
    required: required,
    isAvailable: isAvailable,
    label: context.t(label === undefined ? (0, lodash_1.startCase)(name) : label),
    placeholder: placeholder,
    description: description,
    render: function (props) {
      return react_1.default.createElement(input_select_1.InputSelect, __assign({}, props, {
        maxMenuHeight: args.maxMenuHeight,
        isOptionDisabled: isOptionDisabled,
        options: options,
        isClearable: isClearable,
        isMulti: isMulti
      }));
    }
  };
};
exports.entitySelectField = entitySelectField;